import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import { getListResult } from "../../../utils";
import EditUser from "../components/EditUser";
import { getActivateDeactivateUser, getMfaPreference, getResendRegistration, getResetPassword, updateUserDetails } from "../../../actions/MyAccount";
import { getAdminSelectedUserByEmail } from "../../../actions/AdminActions";
import { MyAccountModel } from "../../../models/MyAccount";
import { ActiveDeActivePayload } from "../../../models/User";
import { getLoggedInUserByEmail } from "../../../actions/UserAction";
import { Numbers } from "../../../constants/Referral";

const mapStateToProps = ({
  masterRoleState,
  masterMfaPreferenceState,
  adminSelectedUserDetailsState,
  masterServiceProviderState,
  getActivateDeActivateUserState,
  updateUserDetailsState
}: ApplicationState) => ({
  masterRoleState: getListResult(masterRoleState.response),
  masterMfaPreferenceState: getListResult(masterMfaPreferenceState.response),
  adminSelectedUserDetailsState: adminSelectedUserDetailsState.response,
  masterServiceProviderDefaultList: masterServiceProviderState.response,
  getActivateDeActivateUserState: getActivateDeActivateUserState.response,
  updateUserDetailsState: updateUserDetailsState.response,
});
const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getMfaPreference: () => {
      dispatch(getMfaPreference());
    },
    getAdminSelectedUserByEmail: (userEmail: string) => {
      dispatch(getAdminSelectedUserByEmail(userEmail));
    },
    updateUserDetails: (payload: MyAccountModel) => {
      dispatch(updateUserDetails(payload));
    },
    getResetPassword: (email: string) => {
      dispatch(getResetPassword(email));
    },
    getResendRegistration: (email: string) => {
      dispatch(getResendRegistration(email));
    },
    getActivateDeactivateUser: (payload: ActiveDeActivePayload) => {
      dispatch(getActivateDeactivateUser(payload));
    },
    getLoggedInUserByEmail: (userEmail: string) => {
      dispatch(getLoggedInUserByEmail(userEmail, Numbers.ONE));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(EditUser);
